<template>
    <section class="content">
      <!-- <keep-alive> -->
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br />
        <h4>Loading...</h4>
      </div>
      <div>
        <div class="box box-info">
          <!-- <Toast style="margin-top: 35px" /> -->
          <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
                <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchSalesSummaryReport" class="p-button-raised" label="Search"
                  icon="pi pi-search" />
                <!-- <button type="submit" style="margin-left:10px;margin-top: 24px;"  @click.prevent="reset"
               class="btn btn-info pull-left">Reset</button> -->
              </div>
            </div>
          </form>
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-col-12">
              <a href="#" @click.prevent="exportCSV()">
                <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;" />
              </a> -->
              <DataTable :value="salesSummaryReportLists" ref="po" :paginator="true" :rowsPerPageOptions="[100, 500, 1000]" :rows="100"
                :filters="filters" class="p-datatable-responsive p-datatable-gridlines" data-key="id" :selection.sync="selectedProduct1" selectionMode="single">
                <template #header>
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
                <Column header="S.N">
                  <template #body="sl">
                    {{ sl.index + 1 }}
                  </template>
                </Column>
                <Column header="Party Name" headerStyle="width:8em;" :sortable="true" field="partyName"
                  filterField="partyName" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['partyName']" />
                  </template>
                </Column>
                <Column header="Pan No" :sortable="true" field="panNo" filterField="panNo" filterMatchMode="contains">
  
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['panNo']" />
                  </template>
                  <template #footer>
                    Total:
                  </template>
                </Column>
                <Column header="Openning" :sortable="true" field="opening" filterField="opening"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['opening']" />
                  </template>
                  <template #footer>
                    {{ totalOpening.toFixed(2) }}
                  </template>
  
                </Column>
                <Column header="Total" :sortable="true" field="total" filterField="total" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['total']" />
                  </template>
                  <template #footer>
                    {{ totalSumBillAmount.toFixed(2) }}
                  </template>
                </Column>

                <Column header="Non-taxable" bodyStyle="text-align: right" field="nonTaxable"
                  filterField="nonTaxable" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['nonTaxable']" />
                  </template>
                  <template #footer>
                    {{ totalNonTaxableAmount.toFixed(2) }}
                  </template>
                </Column>

                <Column header="Taxable" bodyStyle="text-align: right" field="taxable" filterField="taxable"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['taxable']" />
                  </template>
                  <template #footer>
                    {{ totalTaxableAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Vat" bodyStyle="text-align: right" field="vat" filterField="vat"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['vat']" />
                  </template>
                  <template #footer>
                    {{ totalVatAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Closing" bodyStyle="text-align: right" field="closing" filterField="closing"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['closing']" />
                  </template>
                  <template #footer>
                    {{ closingTotalAmount.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Org Name" :sortable="true" field="orgName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orgName']"/>
                </template>
              </Column>
                <template #empty>No record found</template>
              </DataTable>
            <!-- </div>
          </div> -->
        </div>
      </div>
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from '../../layout/dialog'
  import $ from 'jquery'
  import Button from 'primevue/button'
  import InputMask from 'primevue/inputmask'
  import InputText from 'primevue/inputtext'
  
  export default {
    name: 'salesSummaryReport',
    data() {
      return {
        fromDate: null,
        toDate: null,
        salesSummaryReportLists: [],
        loading: false,
        dialogShow: false,
        englishDateEnabled: true,
        selectedProduct1: null,
        filters: {},
        totalOpening: 0,
        totalNonTaxableAmount: 0,
        totalTaxableAmount: 0,
        totalVatAmount: 0,
        totalSumBillAmount: 0,
        closingTotalAmount: 0
      }
    },
    mounted() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    methods: {
      async searchSalesSummaryReport() {
        let dat = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        this.loading = !this.loading
        let resp = await this.$store.dispatch('loadSalesSummaryReportLists', dat)
        this.loading = false
        if (resp.data.data.length <= 0) {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 10000 })
        } else {
          this.salesSummaryReportLists = resp.data.data
          this.totalBalance()
        }
      },
      async viewPIVDetail(data) {
        let PIHdata = {
          id: data.id,
          warehouse: data.warehouse,
          account: data.accountMaster,
          salesDate: data.purchaseSalesDateNepali,
          billNo: data.billNo,
          reportType: data.reportType,
          referenceNumber: data.referenceNumber,
          subTotalAmount: data.subTotalAmount,
          nonTaxableAmount: data.nonTaxableAmount,
          taxableAmount: data.taxableAmount,
          vatAmount: data.vatAmount,
          totalBillAmount: data.totalBillAmount,
          vatTypeEnum: data.vatTypeEnum
        }
        this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      totalBalance() {
        this.totalOpening = 0.0
        this.totalNonTaxableAmount = 0.0
        this.totalTaxableAmount = 0.0
        this.totalVatAmount = 0.0
        this.totalSumBillAmount = 0.0
        this.closingTotalAmount = 0.0
        for (let sale of this.salesSummaryReportLists) {
          this.totalOpening += sale.opening
          this.totalNonTaxableAmount += sale.nonTaxable
          this.totalTaxableAmount += sale.taxable
          this.totalVatAmount += sale.vat
          this.totalSumBillAmount += sale.total
          this.closingTotalAmount += sale.closing
        }
      },
      reset() {
        if (!this.$store.getters.englishDate) {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        } else {
          this.fromDate = new Date().toISOString().slice(0, 10)
          this.toDate = new Date().toISOString().slice(0, 10)
        }
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      Dialog,
      Button,
      InputMask,
      InputText
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// salesSummaryReport.vue?2839d802